
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/select-organization",
      function () {
        return require("private-next-pages/select-organization.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/select-organization"])
      });
    }
  